import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { useMemo } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type ProductBundleAddToCartButtonComponentProps = {
    cart?: Cart | null;
    bundleSkus: Array<string>;
    onAddToCart: () => void;
    addToCartLoading: boolean;
};

const ProductBundleAddToCartButtonComponent = ({
    cart,
    onAddToCart,
    addToCartLoading,
    bundleSkus
}: ProductBundleAddToCartButtonComponentProps) => {
    const { t } = useGranite();
    const bundleInCart = useMemo(
        () =>
            bundleSkus.every((bundleSku) =>
                cart?.items.find((cartItem) => cartItem.sku === bundleSku)
            ),
        [cart?.items, bundleSkus]
    );

    return (
        <Button
            type={"button"}
            color={"primary"}
            disabled={bundleInCart || addToCartLoading}
            outline={bundleInCart}
            onClick={onAddToCart}
        >
            <i
                className={cn("las la-lg d-md-none", {
                    "la-plus": !bundleInCart && !addToCartLoading,
                    "la-check": bundleInCart && !addToCartLoading,
                    "la-spinner la-pulse": addToCartLoading
                })}
            ></i>
            <i className="las la-lg la-shopping-cart d-md-none"></i>
            <span className="d-none d-md-inline-block">
                {t("ecommerce.button.order")}{" "}
                <i className="la-md las la-angle-right"></i>
            </span>
        </Button>
    );
};

export { ProductBundleAddToCartButtonComponent };
